import React from 'react';
import { FormControl, FormLabel, RadioGroup, FormControlLabel, Radio } from '../../../../third-party-components/material-ui';

class TaskRadioGroupButtons extends React.Component {
    render() {
        const {name, label, value, className= '', data, textField, onChange, inline} = this.props;
        let selectedValue = -1;

        if (value && isNaN(value) === false) {
            selectedValue = parseInt(value);
        }

        return (
            <React.Fragment>
                <FormControl className={`task-radio-group-button ${className}`} component="fieldset">
                    <FormLabel className="task-radio-group-button-label" component="div">{label}</FormLabel>
                    <RadioGroup aria-label="position" name={name} onChange={onChange} style={{display: inline ? 'inline' : 'online'}} row>
                        {data.map((option, index) => (
                            <FormControlLabel
                                key={index}
                                value={option.value}
                                control={
                                    <Radio color="primary" checked={selectedValue === option.value} />
                                }
                                label={option[textField]}
                                labelPlacement="end"
                            />
                        ))}
                    </RadioGroup>
                </FormControl>
            </React.Fragment>
        )
    }
}

export default TaskRadioGroupButtons;